import { useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

/**
 * Critical CSS Loader for Mobile
 * Dynamically loads non-critical CSS after initial render
 */
export const CriticalCSSLoader = () => {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) return;

    // Defer loading of non-critical CSS
    const loadDeferredCSS = () => {
      // Load fonts after initial render
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
      fontLink.media = 'print';
      fontLink.onload = function() {
        (this as HTMLLinkElement).media = 'all';
      };
      document.head.appendChild(fontLink);
    };

    // Defer until after initial render
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadDeferredCSS);
    } else {
      setTimeout(loadDeferredCSS, 1);
    }
  }, [isMobile]);

  return null;
};
